import React, { Component } from 'react';
import './Worker.css';
import en from '../../../language/en/Worker.json';
import es from '../../../language/es/Worker.json';
import { Link, withRouter } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
// import { Slide, Fade } from "react-slideshow-image";
// import AwesomeSlider from "react-awesome-slider";
import 'react-awesome-slider/dist/styles.css';
import config from '../../../config/config.json';

class Worker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			worker: {}/* ,
			nextWorkerId: 0,
			childsId: [] */
			, slide: true
		};

		window.scrollTo(0, 1);
		setInterval(() => this.setState({ slide: !this.state.slide }), 2000);
	}

	componentDidMount() {
		// console.log('componentDidMount')
		let url = `${config.apiBaseUrl}/trabajador/${this.props.match.params.id}`;
		// console.log(url)
		//Obteniendo todos los servicios del centro
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				worker => {
					console.log('worker = ', worker);
					this.setState({
						worker
					});
				}
			)
			.catch(
				err => {
					console.log("error ", err);
				}
			);

		// const {nextChild} = this.props.location.state;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// console.log('componentDidUpdate(prevProps, prevState, snapshot)');
		// console.log('componentDidUpdate(prevProps, prevState, snapshot)', prevProps);
		// console.log('componentDidUpdate(prevProps, prevState, snapshot)', prevState);

		if (this.state.worker.id !== this.props.match.params.id) {
			let url = `${config.apiBaseUrl}/trabajador/${this.props.match.params.id}`;

			//Obteniendo todos los servicios del centro
			fetch(url)
				.then(
					res => {
						return res.json();
					}
				)
				.then(
					worker => {
						// console.log('worker = ', worker);
						this.setState({
							worker
						});
					}
				)
				.catch(
					err => {
						console.log("error ", err);
					}
				);
		}
	}

	render() {
		console.log('props', this.props);
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		const { worker/* , nextWorkerId, childsId */ } = this.state;

		const { childsId } = this.props.location.state !== undefined ? this.props.location.state : { childsId: [] };

		let previousWorkerId = this.props.match.params.id, nextWorkerId = this.props.match.params.id;
		if (childsId !== []) {
			for (let index = 0; index < childsId.length; index++)
				if (childsId[index] === worker.id) {
					nextWorkerId = childsId[(index + 1) % childsId.length];
					previousWorkerId = childsId[(index - 1 + childsId.length) % childsId.length];
				}
		}
		// console.log('nextWorkerId', nextWorkerId);

		const slideImages = [
			'/assets/frontend/onepage2/img/bg/bg_slider1.jpg',
			'/assets/frontend/onepage2/img/bg/bg_slider2.jpg',
			'/assets/frontend/onepage2/img/bg/bg_slider3.jpg'
		];

		const fadeProperties = {
			duration: 3000,
			transitionDuration: 1000,
			infinite: true,
			indicators: true,
			arrows: true
		}

		return (
			<div className="Worker">

				{/* <Fade {...fadeProperties}>
					<div className="each-slide">
						<div style={{ 'backgroundImage': `url(${slideImages[0]})` }}>
							<span className={this.state.slide ? 'slide' : ''}>Slide 1</span>
						</div>
					</div>
					<div className="each-slide">
						<div style={{ 'backgroundImage': `url(${slideImages[1]})` }}>
							<span className={this.state.slide ? 'slide' : ''}>Slide 2</span>
						</div>
					</div>
					<div className="each-slide">
						<div style={{ 'backgroundImage': `url(${slideImages[2]})` }}>
							<span className={this.state.slide ? 'slide' : ''}>Slide 3</span>
						</div>
					</div>
				</Fade> */}
				{/* <AwesomeSlider cssModule={{ height: '300px' }}>
					<div data-src={ slideImages[0] }></div>
					<div data-src={ slideImages[1] }></div>
					<div data-src={ slideImages[2] }></div>
				</AwesomeSlider> */}

				<div className="container">
					{/* <div className="heading">
						<h2><strong>Worker {this.props.match.params.id}</strong></h2>
					</div> */}
					{/* <ul className="pager">
						<li className="previous">
							<Link to={{
								pathname: '/worker/' + previousWorkerId,
								state: {
									childsId
								}
							}} className="btn-brd-primary">
								← Anterior
							</Link>
						</li>
						<li className="next">
							<Link to={{
								pathname: '/worker/' + nextWorkerId,
								state: {
									childsId
								}
							}} className="btn-brd-primary">
								Siguiente →
							</Link>
						</li>
					</ul> */}
					<div className="row">

						{/* Contenido: Profile */}
						<div className="col-md-12">
							{/* BEGIN PROFILE SIDEBAR */}
							<div className="profile">
								{/* PORTLET MAIN */}
								<div className="portlet light profile-sidebar-portlet">
									<Link to="/cmp/workers">
										<i className="fa fa-reply"></i>Workers Page
									</Link>
									
									{/* SIDEBAR USERPIC */}
									<ReactCSSTransitionGroup
										transitionName="avatar"
										transitionAppear={true}
										component="div"
										className="profile-userpic">
										<img src={worker.avatar} className="img-responsive" alt="" />
									</ReactCSSTransitionGroup>
									{/* END SIDEBAR USERPIC */}
									{/* SIDEBAR USER TITLE */}
									<div className="profile-usertitle">
										<div className="profile-usertitle-name">
											{worker.nombre + ' ' + worker.apellidos}
										</div>
										<div className="profile-usertitle-job">
											{worker.plaza}
										</div>
									</div>
									{/* END SIDEBAR USER TITLE */}
									{/* SIDEBAR BUTTONS */}
									<div className="profile-userbuttons">
										<button type="button" className="btn btn-circle green-haze btn-sm">Follow</button>
										<button type="button" className="btn btn-circle btn-danger btn-sm">Message</button>
									</div>
									{/* END SIDEBAR BUTTONS */}
									{/* SIDEBAR MENU */}
									<div className="profile-usermenu">
										<ul className="nav">
											<li className="active">
												<a href="extra_profile.html">
													<i className="icon-home"></i>
												Overview </a>
											</li>

											<li>
												<a href="page_todo.html" target="_blank">
													<i className="icon-check"></i>
												Tasks </a>
											</li>
											<li>
												<a href="extra_profile_help.html">
													<i className="icon-info"></i>
												Help </a>
											</li>
										</ul>
									</div>
									{/* END MENU */}
								</div>
								{/* END PORTLET MAIN */}
								{/* PORTLET MAIN */}
								<div className="portlet light">
									{/* STAT */}
									<div className="row list-separated profile-stat">
										<div className="col-md-4 col-sm-4 col-xs-6">
											<div className="uppercase profile-stat-title">
												37
											</div>
											<div className="uppercase profile-stat-text">
												Projects
											</div>
										</div>
										<div className="col-md-4 col-sm-4 col-xs-6">
											<div className="uppercase profile-stat-title">
												51
											</div>
											<div className="uppercase profile-stat-text">
												Tasks
											</div>
										</div>
										<div className="col-md-4 col-sm-4 col-xs-6">
											<div className="uppercase profile-stat-title">
												61
											</div>
											<div className="uppercase profile-stat-text">
												Uploads
											</div>
										</div>
									</div>
									{/* END STAT */}
									<div>
										<h4 className="profile-desc-title">About {worker.nombre + ' ' + worker.apellidos}</h4>
										<span className="profile-desc-text">
											Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officiis aut eos reprehenderit earum quaerat cum! Eaque provident vero ea facere, id architecto quibusdam facilis, modi, iure repellat alias ab sed.
										</span>
										<div className="margin-top-20 profile-desc-link">
											<i className="fa fa-globe"></i>
											<a href="http://www.keenthemes.com">www.keenthemes.com</a>
										</div>
										<div className="margin-top-20 profile-desc-link">
											<i className="fa fa-twitter"></i>
											<a href="http://www.twitter.com/keenthemes/">@keenthemes</a>
										</div>
										<div className="margin-top-20 profile-desc-link">
											<i className="fa fa-facebook"></i>
											<a href="http://www.facebook.com/keenthemes/">keenthemes</a>
										</div>
									</div>
								</div>
								{/* END PORTLET MAIN */}
							</div>
							{/* END BEGIN PROFILE SIDEBAR */}
							{/* BEGIN PROFILE CONTENT */}

							{/* END PROFILE CONTENT */}
						</div>

					</div>
				</div>
			</div>
		)
	}
}

export default withRouter(Worker);